import useBodyScrollLock from '@hooks/useBodyScrollLock';
import ViewInAR from '@img/backgrounds/viewInAR.png';
import Camera from '@img/icons/camera.svg';
import Close from '@img/icons/plus.svg';
import QrCode from '@img/mobile-apps/8thwall.png';
import Button from '@stories/Elements/Forms/Buttons/Button';
import React, { FunctionComponent, useState } from 'react';
import { TryThemOnStyles as S } from './TryThemOn.styles';

export interface TryThemOnProps {
  translations: Record<string, string | undefined>;
}

const TryThemOn: FunctionComponent<TryThemOnProps> = ({ translations }) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const scrollableRef = useBodyScrollLock<HTMLDivElement>(modalVisible);

  return (
    <>
      <S.Container>
        <Button
          text={translations['custom.view-in-ar']}
          theme="red"
          iconPlacement="before"
          icon="view-in-ar"
          iconVisibility="always"
          onClick={() => setModalVisible(true)}
        />
      </S.Container>

      {modalVisible && (
        <S.ModalContainer onClick={() => setModalVisible(false)}>
          <S.ModalWrapper
            ref={scrollableRef}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <S.CloseButtonWrapper onClick={() => setModalVisible(false)}>
              <Close />
            </S.CloseButtonWrapper>
            <S.SplitContainer>
              <S.ContentContainer>
                <S.Title>{translations['custom.view-in-ar.title']}</S.Title>
                <S.Subtitle>{translations['custom.view-in-ar.subtitle']}</S.Subtitle>
                <S.SplitIconContainer>
                  <S.IconWrapper
                    href="https://ar.milwaukeetool.eu/milwaukee-ar/"
                    target="_blank"
                    highlightOnHover={true}
                  >
                    <S.Icon>
                      <Camera />
                    </S.Icon>
                    <S.IconText>{translations['custom.view-in-ar.camera-description']}</S.IconText>
                  </S.IconWrapper>
                  <S.OrContainer>
                    <S.Or>{translations['custom.view-in-ar.dividing-word']}</S.Or>
                  </S.OrContainer>
                  <S.IconWrapper>
                    <S.Icon>
                      <img src={QrCode} />
                    </S.Icon>
                    <S.IconText>{translations['custom.view-in-ar.qr-description']}</S.IconText>
                  </S.IconWrapper>
                </S.SplitIconContainer>
              </S.ContentContainer>
              <S.SideImage src={ViewInAR} />
            </S.SplitContainer>
          </S.ModalWrapper>
        </S.ModalContainer>
      )}
    </>
  );
};

export default TryThemOn;
